import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/pos-txn", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/pos-txn/csv", params);
};

const upsert = data => {
  return restApi.post("/api/pos-txn/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/pos-txn/${ids}`);
};

const posTxnService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default posTxnService;
